<template>
  <div class="aMap">
    <div class="map" id="map"></div>
    <!--v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)"-->
    <div class="point">
      <i class="el-icon-location"></i>
      当前显示范围：
      <el-switch
        v-model="selectId"
        active-color="rgba(170, 253, 254, .5)"
        inactive-color="rgba(255, 255, 255, .5)"
        :inactive-value="1"
        :active-value="440000"
        active-text="广东省"
        inactive-text="全国"
      >
      </el-switch>
      <!--<ElementSelect :val="selectId"-->
      <!--               :options="selectList"-->
      <!--               :transfer="false"-->
      <!--               @change="changeSelect" />-->
    </div>
    <div class="map-radio-box" v-if="selectId > 1">
      <div class="name">
        <span></span>
        地图渲染对象：
      </div>
      <el-radio-group v-model="typeId">
        <el-radio :label="1">会员总数</el-radio>
        <el-radio :label="2">全国民营企业500强企业分布</el-radio>
      </el-radio-group>
    </div>
    <div class="map-color-box" v-if="selectId > 1">
      <div class="num-box">
        <span>{{ selectId > 1 ? countGuangdong : count }}</span>
        <span>{{ selectId > 1 ? cityMinNum : minNum }}</span>
      </div>
      <div class="map-color"></div>
    </div>
    <!--<transition name="el-fade-in">-->
    <div
      class="map-loading"
      v-loading="loading"
      v-if="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    ></div>
    <!--</transition>-->
  </div>
</template>

<script>
import ElementSelect from '../../../components/element-select';
import { getMapData } from '../../../api/getMapData';
import GisInfoBox from '../../../components/map/GisInfoBox';

export default {
  name: 'AMap',
  components: { ElementSelect },
  data() {
    return {
      selectId: 1,
      selectList: [
        {
          value: 1,
          label: '全国',
        },
        {
          value: 440000,
          label: '广东省',
        },
      ],
      proCenter: [113.28, 23.125],
      loading: false,
      map: null,
      AMap: null,
      valData: {},
      maxNum: 0,
      minNum: 0,
      count: null,
      cityValData: {},
      cityMaxNum: 0,
      cityMinNum: 0,
      countGuangdong: null,
      mapObj: {
        disCity: [],
        cityBoundariesLoaded: false,
        cityBoundariesLoading: false,
        loadedCityAdcodes: new Set(),
        lastLoadTime: 0, // 上次加载时间戳
        isSettingLabels: false, // 标记是否正在设置标签
      },
      // 防抖相关
      setLabelsDebounceTimer: null,
        typeId: 1,
      // 全国企业500强
      countryQuotaData: {},
      // 广东企业500强
      cityQuotaData: {},
    };
  },
  watch: {
    selectId(n) {
      // this.getData();
      this.showProvince();
      this.$emit('mapCode', {
        code: n,
      });
    },
    typeId(n) {
      console.log(n, '-n');
      this.setCityColor();
    },
    loading(n) {
      this.$emit('loading', n);
    },
  },
  computed: {
    isGuangdong() {
      return this.selectId === 440000;
    },
  },
  methods: {
    changeSelect(e) {
      this.selectId = e;
    },
    showProvince() {
      let { map, AMap } = this;
      this.loading = true;
      let {
        disCountry,
        disProvince,
        disProGuangDong,
        disCity,
        layerProvince,
        layerCity,
        focusProvince,
        polygonCity,
        label,
      } = this.mapObj;

      // disCountry.hide();
      // disProvince.hide();
      disCountry && disCountry.setMap(null);
      disProvince && disProvince.setMap(null);
      disProGuangDong && disProGuangDong.setMap(null);
      focusProvince.setDistricts('');
      focusProvince.setMap(map);
      map.remove(disProvince);
      label?.hide();
      if (disCity) {
        disCity.map((item) => {
          item.hide();
        });
      }
      if (polygonCity) {
        map.remove(polygonCity); //清除上次结果
        polygonCity = null;
      }
      if (this.selectId > 1) {
        layerProvince.hide();
        layerCity.show();
        this.getProvinceMap();
        let pos = [this.proCenter[0] + 0.05, this.proCenter[1] - 0.5];
        map?.setCenter(pos, false, 50);
        map?.setZoom(7.4);
      } else {
        layerCity.hide();
        layerProvince.show();
        this.getCountryMap();
        map?.setCenter([104.122082, 36.719192], false, 50);
        map.setZoom(4.5);
      }
      // map.setFitView();
      this.mapListen();

      setTimeout(() => {
        this.loading = false;
      }, 1500);
    },
    getColorByVal(name, focus, city) {
      var colors = {};
      let max = city ? this.cityMaxNum : this.maxNum,
        min = city ? this.cityMinNum : this.minNum;

      let r = 73,
        g = 243,
        b = 243;
      let colorArr = [
        {
          r: 0,
          g: 120,
          b: 255,
          a: 0.3,
        },
        {
          r: 0,
          g: 201,
          b: 255,
        },
        {
          r: 88,
          g: 236,
          b: 172,
        },
        {
          r: 252,
          g: 245,
          b: 194,
        },
      ];
      let a = null;

      if (city) {
        name = name.replace('市', '');
      }
      if (!colors[name]) {
        var val = city ? this.cityValData[name] : this.valData[name];
        if (city && this.typeId === 2) {
          let valObj = {};
          this.cityQuotaData.map((item) => {
            valObj[item.cityName] = item.total;
          });
          let arr = this.cityQuotaData.map((item) => item.total);
          arr = arr.sort(function (a, b) {
            return a - b;
          });

          max = arr[arr.length - 1];
          min = arr[0];
          val = valObj[name + '市'];
          console.log(max, min, valObj, val, name);
        }
        if (!val) {
          colors[name] = 'rgba(27, 95, 152, .5)';
          // colors[adcode] = 'rgba(73, 243, 243, .75)'
        } else {
          let pro = val / max;
          if (val === min) {
            let { r, g, b } = colorArr[0];
            a = 0.8;
            colors[name] = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
          } else if (pro <= 0.36) {
            let { r, g, b } = colorArr[1];
            a = (val / (max * 0.36)) * 0.8;
            // a = val / ( max * 0.36 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          } else if (pro <= 0.71) {
            let { r, g, b } = colorArr[2];
            a = (val / (max * 0.71)) * 0.8;
            // a = val / ( max * 0.71 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          } else if (pro <= 1) {
            let { r, g, b } = colorArr[3];
            a = (val / max) * 0.8;
            // a = val / ( max * 0.8 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          }
          // a = val / max * 0.75;
          // colors[name] =
          //   // val !== max ?
          //   val <= min ?
          //     'rgba(27, 95, 152, .5)' :
          //     'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
        }
      }
      // a ? a = Math.round(a.toFixed(2) * 100) / 100 : ''
      if (focus) {
        colors[name] = 'rgba(231, 223, 180, .8)';
      }
      return city ? [colors[name], a ? a : '.3'] : colors[name];
    },
    getData() {
      // 全国数据 - 暂不使用
      // getMapData('Country').then(async res => {
      //   let dataObj = {};
      //   let name = this.selectId > 1 ? '地市' : '省份';
      //   await res.map(item => {
      //     item[name] === '合计' ? this.count = Number(item['会员总数']) : '';
      //     item[name] !== '合计' ? dataObj[item[name]] = Number(item['会员总数']) : '';
      //   });
      //   this.valData = dataObj;
      //   let arr = [];
      //   for (let key in dataObj) {
      //     arr.push(dataObj[key]);
      //   }
      //   arr = arr.sort(function (a, b) {
      //     return a - b
      //   });
      //
      //   let max = arr[arr.length - 1], min = arr[0];
      //   this.maxNum = max;
      //   this.minNum = min;
      // })

      this.$api.screen.getGdMembersData().then((res) => {
        let { data } = res.data;
        let dataObj = {};
        data.map((item) => {
          dataObj[item.name] = item.membersTotal;
        });
        this.cityValData = dataObj;
        let arr = [];
        for (let key in dataObj) {
          arr.push(dataObj[key]);
        }
        arr = arr.sort(function (a, b) {
          return a - b;
        });

        let max = arr[arr.length - 1],
          min = arr[0];
        this.cityMaxNum = max;
        this.cityMinNum = min;
      });

      this.$api.screen.getMapCountryEnQuota().then((res) => {
        this.countryQuotaData = res.data.data;
      });

      this.$api.screen.getMapCityEnQuota().then((res) => {
        this.cityQuotaData = res.data.data;
      });

      // getMapData('Guangdong').then(async res => {
      //   let dataObj = {};
      //   await res.map(item => {
      //     item['地市'] === '合计' ? this.countGuangdong = Number(item['会员总数']) : '';
      //     item['地市'] !== '合计' ? dataObj[item['地市']] = Number(item['会员总数']) : '';
      //   });
      //   this.cityValData = dataObj;
      //   let arr = [];
      //   for (let key in dataObj) {
      //     arr.push(dataObj[key]);
      //   }
      //   arr = arr.sort(function (a, b) {
      //     return a - b
      //   });
      //
      //   let max = arr[arr.length - 1], min = arr[0];
      //   this.cityMaxNum = max;
      //   this.cityMinNum = min;
      // })
    },
    getCountryMap() {
      var disCountry = new AMap.DistrictLayer.Country({
        zIndex: 1,
        SOC: 'CHN',
        depth: 1,
        styles: {
          'nation-stroke': 'rgb(67, 242, 243)',
          'coastline-stroke': 'rgb(67, 242, 243)',
          'province-stroke': 'rgba(0, 0, 0, 0)',
          'stroke-width': 4,
          fill: function (props) {
            return 'rgba(27, 95, 152, .6)';
            // return "rgba(0, 0, 0, .1)"
          },
        },
      });
      let proOptions = {
        zIndex: 20,
        depth: 0,
        styles: {
          'province-stroke': '#49f3f3',
          'stroke-width': 1,
          fill: (props) => {
            return '';
            // return this.getColorByVal(props.NAME_CHN)
          },
        },
      };
      let disProvince = new AMap.DistrictLayer.Province(proOptions);
      this.mapObj.disCountry = disCountry;
      this.mapObj.disProvince = disProvince;
      this.mapObj.proOptions = proOptions;
      this.map ? this.mapObj.disCountry.setMap(this.map) : '';
      this.map ? this.mapObj.disProvince.setMap(this.map) : '';
    },
    getProvinceMap() {
      let { disCity } = this.mapObj;
      let disProGuangDong = new AMap.DistrictLayer.Province({
        adcode: [this.selectId],
        zIndex: 20,
        depth: 0,
        // depth: 1,
        styles: {
          'province-stroke': '#43f2f3',
          'stroke-width': 3,
          // 'city-stroke': '#49f3f3',
          fill: (props) => {
            return 'rgba(27, 95, 152, .1)';
            // return 'rgba(27, 95, 152, .6)'
            // return this.getColorByVal(props.NAME_CHN, false, true)
          },
        },
      });
      disProGuangDong.setMap(this.map);
      // disProGuangDong.hide();
      this.mapObj.disProGuangDong = disProGuangDong;

      if (disCity?.length) {
        disCity.map((item) => {
          item.show();
        });
      }
    },
    getProvinceFocus() {
      let focusProvince = new AMap.DistrictLayer.Province({
        zIndex: 29,
        depth: 0,
        styles: {
          'province-stroke': '#49f3f3',
          'stroke-width': 1,
          fill: (props) => {
            return this.getColorByVal(props.NAME_CHN, true);
          },
        },
      });
      this.mapObj.focusProvince = focusProvince;
      focusProvince.show();
    },
    getLabelsData() {
      let { AMap } = this;
      let provinceData = [],
        cityData = [];

      var districtSearch = new AMap.DistrictSearch({
        // adcode: 440000,
        level: 'country',
        extensions: 'all',
        subdistrict: 2, //  显示下级行政区级数
      });

      districtSearch.search('中国', (status, result) => {
        if (status == 'complete') {
          provinceData = result.districtList[0].districtList;
          this.mapObj.provinceData = [...provinceData];
          this.setLabels();
        }
      });
    },
    initMap() {
      // AMap 对象
      this.AMap = window.AMap;
      this.getCountryMap();
      // this.getProvinceMap();
      this.getProvinceFocus();
      this.getLabelsData();
      let { disCountry, disProvince } = this.mapObj;

      // var defaultLayer = new AMap.createDefaultLayer();
      var map = new AMap.Map('map', {
        zooms: [4, 10],
        center: [104.122082, 36.719192],
        // center: [106.122082, 33.719192],
        zoom: 4.5,
        isHotspot: false,
        defaultCursor: 'pointer',
        // resizeEnable: false,
        // dragEnable: false,
        // zoomEnable: false,
        // scrollWheel: false,
        // touchZoom: false,
        layers: [
          disCountry,
          // defaultLayer
        ],
        viewMode: '2D',
      });
      disProvince.setMap(map);

      this.map = map;

      document.getElementsByClassName('amap-mcode')[0].innerHTML = '';

      this.$nextTick(() => {
        this.mapListen();
      });
    },

    // setLabels(adcode = '', city) {
    //   let { map, AMap } = this;
    //   let { layerProvince, provinceData, layerCity, cityData, disCity, label } = this.mapObj;
    //   let isSelected = false;
    //   let labelObj = {
    //       position: [],
    //       text: {
    //         content: '',
    //         direction: 'center',
    //         style: {
    //           fillColor: '#fff',
    //           strokeColor: 'rgba(255, 255, 255, .1)',
    //         },
    //       },
    //     },
    //     selectStyle = {
    //       fillColor: '#000',
    //       strokeColor: 'rgba(255, 255, 255, .1)',
    //     };
    //
    //   if (layerProvince) {
    //     map.remove(layerProvince);
    //   }
    //   if (layerCity) {
    //     map.remove(layerCity);
    //   }
    //
    //   layerProvince = new AMap.LabelsLayer({
    //     collision: false, // 开启标注避让
    //     animation: true, // 开启标注淡入动画
    //   });
    //   this.mapObj.layerProvince = layerProvince;
    //   layerCity = new AMap.LabelsLayer({
    //     collision: false, // 开启标注避让
    //     animation: true, // 开启标注淡入动画
    //   });
    //   this.mapObj.layerCity = layerCity;
    //
    //   // 选中文字样式
    //   if (!label) {
    //     label = new AMap.LabelMarker({
    //       ...labelObj,
    //       text: {
    //         direction: 'center',
    //         style: selectStyle,
    //       },
    //     });
    //     map.add(label);
    //     this.mapObj.label = label;
    //     label.hide();
    //   }
    //
    //   for (let i = 0; i < provinceData?.length; i++) {
    //     isSelected = adcode && adcode == provinceData[i].adcode;
    //     !cityData?.length && provinceData[i].name === '广东省'
    //       ? (cityData = JSON.parse(JSON.stringify(provinceData[i].districtList)))
    //       : [];
    //
    //     let data = provinceData[i];
    //     let boxHtml = this.$u.createElm('div');
    //     boxHtml.appendChild(
    //       this.$u.drawDialog(GisInfoBox, {
    //         cityName: data.name,
    //         type: 1,
    //         dataObj: this.countryQuotaData,
    //       }),
    //     );
    //     let infoWindow = new AMap.InfoWindow({
    //       isCustom: true, //使用自定义窗体
    //       content: boxHtml,
    //       offset: new AMap.Pixel(0, -10),
    //     });
    //     infoWindow.off('mouseover').on('mouseover', (e) => {
    //       let center = [data.center.lng, data.center.lat];
    //       infoWindow.open(map, center);
    //     });
    //
    //     infoWindow.off('mouseout').on('mouseout', (e) => {
    //       infoWindow.close();
    //     });
    //
    //     let obj = {
    //       ...labelObj,
    //       position: [provinceData[i].center.lng, provinceData[i].center.lat],
    //     };
    //     obj.text.content = provinceData[i].name;
    //     if (isSelected && adcode !== 440000) {
    //       label.setPosition(obj.position);
    //       label.setText({
    //         content: obj.text.content,
    //       });
    //       label.show();
    //     }
    //     let labelsMarker = new AMap.LabelMarker(obj);
    //     labelsMarker.on('click', (e) => {
    //       this.provinceListen(e);
    //     });
    //
    //     labelsMarker.off('mouseover').on('mouseover', (e) => {
    //       let center = [data.center.lng, data.center.lat];
    //       infoWindow.open(map, center);
    //     });
    //     labelsMarker.off('mouseout').on('mouseout', (e) => {
    //       infoWindow.close();
    //     });
    //     !isSelected ? layerProvince.add(labelsMarker) : '';
    //   }
    //   map.add(layerProvince);
    //   city ? layerProvince.hide() : '';
    //
    //   for (let i = 0; i < cityData.length; i++) {
    //     isSelected = adcode && adcode == cityData[i].adcode;
    //     let citySearch = new AMap.DistrictSearch({
    //       // adcode: 440000,
    //       level: 'city',
    //       // level: "district",
    //       extensions: 'all',
    //       subdistrict: 0, //  显示下级行政区级数
    //     });
    //
    //     if (!disCity?.length) {
    //       let data = cityData[i];
    //       let colorArr = this.getColorByVal(data.name, false, true);
    //       citySearch.search(cityData[i].adcode, (status, result) => {
    //         if (status === 'complete') {
    //           let bounds = result.districtList[0].boundaries;
    //           if (bounds) {
    //             //生成行政区划polygon
    //             for (var j = 0; j < bounds.length; j += 1) {
    //               //构造MultiPolygon的path
    //               bounds[j] = [bounds[j]];
    //             }
    //             disCity[i] = new AMap.Polygon({
    //               zIndex: 30,
    //               strokeWeight: 1,
    //               path: bounds,
    //               strokeColor: '#49f3f3',
    //               fillOpacity: colorArr[1],
    //               fillColor: colorArr[0],
    //               // fillColor: '#49f3f3',
    //             });
    //             map.add(disCity[i]);
    //             disCity[i].hide();
    //             this.mapObj.disCity[i] = disCity[i];
    //
    //             let boxHtml = this.$u.createElm('div');
    //             boxHtml.appendChild(
    //               this.$u.drawDialog(GisInfoBox, {
    //                 cityName: data.name,
    //                 type: 2,
    //               }),
    //             );
    //             let infoWindow = new AMap.InfoWindow({
    //               isCustom: true, //使用自定义窗体
    //               content: boxHtml,
    //               offset: new AMap.Pixel(0, -10),
    //             });
    //
    //             disCity[i].off('mouseover').on('mouseover', (e) => {
    //               // infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat]);
    //               infoWindow.open(map, cityData[i].center);
    //             });
    //
    //             infoWindow.off('mouseover').on('mouseover', (e) => {
    //               // infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat]);
    //               infoWindow.open(map, cityData[i].center);
    //             });
    //
    //             disCity[i].off('mouseout').on('mouseout', (e) => {
    //               infoWindow.close();
    //             });
    //
    //             infoWindow.off('mouseout').on('mouseout', (e) => {
    //               infoWindow.close();
    //             });
    //
    //             disCity[i].off('click').on('click', (e) => {
    //               this.$emit('mapCode', {
    //                 code: 440000,
    //                 name: data.name.split('市')[0],
    //               });
    //               this.cityListen(e, { infoWindow, infoWindowData: cityData[i] });
    //             });
    //           }
    //         }
    //       });
    //     }
    //     let obj = {
    //       ...labelObj,
    //       position: cityData[i].center,
    //     };
    //     obj.text.content = cityData[i].name;
    //     if (isSelected) {
    //       label.setPosition(obj.position);
    //       label.setText({
    //         content: obj.text.content,
    //       });
    //       label.show();
    //     }
    //     let labelsMarker = new AMap.LabelMarker(obj);
    //     labelsMarker.off('click').on('click', (e) => {
    //       this.$emit('mapCode', {
    //         code: 440000,
    //         name: cityData[i].name.split('市')[0],
    //       });
    //       this.cityListen(e);
    //     });
    //     !isSelected ? layerCity.add(labelsMarker) : '';
    //   }
    //   map.add(layerCity);
    //   !city ? layerCity.hide() : '';
    // },

      setLabels(adcode = '', city) {
          // 防抖处理，500ms内多次调用只执行一次
          if (this.setLabelsDebounceTimer) {
              clearTimeout(this.setLabelsDebounceTimer);
          }

          this.setLabelsDebounceTimer = setTimeout(() => {
              this._setLabels(adcode, city);
          }, 500);
      },

// 实际执行的方法
      async _setLabels(adcode = '', city) {
          // 检查是否正在执行
          if (this.mapObj.isSettingLabels) {
              console.log('setLabels正在执行中，跳过本次调用');
              return;
          }

          this.mapObj.isSettingLabels = true;

          try {
              let { map, AMap } = this;
              let {
                  layerProvince,
                  provinceData,
                  layerCity,
                  cityData,
                  disCity,
                  label,
                  cityBoundariesLoaded,
                  cityBoundariesLoading,
                  loadedCityAdcodes,
                  lastLoadTime
              } = this.mapObj;
              let isSelected = false;
              let labelObj = {
                      position: [],
                      text: {
                          content: '',
                          direction: 'center',
                          style: {
                              fillColor: '#fff',
                              strokeColor: 'rgba(255, 255, 255, .1)',
                          },
                      },
                  },
                  selectStyle = {
                      fillColor: '#000',
                      strokeColor: 'rgba(255, 255, 255, .1)',
                  };

              // 检查是否需要完全重新加载
              const now = Date.now();
              const shouldFullReload = now - lastLoadTime > 30000; // 30秒后完全重新加载

              // 如果不是完全重新加载，且边界已加载，只更新显示状态
              if (!shouldFullReload && cityBoundariesLoaded && disCity && disCity.length > 0) {
                  console.log('使用已缓存的边界数据，只更新显示状态');

                  // 重新创建标签图层
                  this.cleanupLayersOnly();

                  layerProvince = new AMap.LabelsLayer({
                      collision: false,
                      animation: true,
                  });
                  this.mapObj.layerProvince = layerProvince;
                  layerCity = new AMap.LabelsLayer({
                      collision: false,
                      animation: true,
                  });
                  this.mapObj.layerCity = layerCity;

                  // 重新添加省份标签
                  for (let i = 0; i < provinceData?.length; i++) {
                      isSelected = adcode && adcode == provinceData[i].adcode;
                      !cityData?.length && provinceData[i].name === '广东省'
                          ? (cityData = JSON.parse(JSON.stringify(provinceData[i].districtList)))
                          : [];

                      let data = provinceData[i];
                      let boxHtml = this.$u.createElm('div');
                      boxHtml.appendChild(
                          this.$u.drawDialog(GisInfoBox, {
                              cityName: data.name,
                              type: 1,
                              dataObj: this.countryQuotaData,
                          }),
                      );
                      let infoWindow = new AMap.InfoWindow({
                          isCustom: true,
                          content: boxHtml,
                          offset: new AMap.Pixel(0, -10),
                      });
                      infoWindow.off('mouseover').on('mouseover', (e) => {
                          let center = [data.center.lng, data.center.lat];
                          infoWindow.open(map, center);
                      });

                      infoWindow.off('mouseout').on('mouseout', (e) => {
                          infoWindow.close();
                      });

                      let obj = {
                          ...labelObj,
                          position: [provinceData[i].center.lng, provinceData[i].center.lat],
                      };
                      obj.text.content = provinceData[i].name;
                      if (isSelected && adcode !== 440000) {
                          if (!this.mapObj.label) {
                              this.mapObj.label = new AMap.LabelMarker({
                                  ...labelObj,
                                  text: {
                                      direction: 'center',
                                      style: selectStyle,
                                  },
                              });
                              map.add(this.mapObj.label);
                          }
                          this.mapObj.label.setPosition(obj.position);
                          this.mapObj.label.setText({
                              content: obj.text.content,
                          });
                          this.mapObj.label.show();
                      }
                      let labelsMarker = new AMap.LabelMarker(obj);
                      labelsMarker.on('click', (e) => {
                          this.provinceListen(e);
                      });

                      labelsMarker.off('mouseover').on('mouseover', (e) => {
                          let center = [data.center.lng, data.center.lat];
                          infoWindow.open(map, center);
                      });
                      labelsMarker.off('mouseout').on('mouseout', (e) => {
                          infoWindow.close();
                      });
                      !isSelected ? layerProvince.add(labelsMarker) : '';
                  }
                  map.add(layerProvince);
                  city ? layerProvince.hide() : '';

                  // 重新添加城市标签
                  this.processCityLabels(cityData, adcode, city, labelObj, selectStyle, this.mapObj.label, layerCity, map);

                  // 更新边界显示状态
                  this.updateCityBoundariesVisibility(city);

                  this.mapObj.lastLoadTime = now;
                  this.mapObj.isSettingLabels = false;
                  return;
              }

              // 完全重新加载
              console.log('执行完全重新加载');
              this.cleanupMapLayers();

              // 重置数组但保留已加载的数据
              if (!disCity) {
                  this.mapObj.disCity = [];
              } else {
                  // 从地图上移除，但保留在数组中
                  disCity.forEach(polygon => {
                      if (polygon && map) {
                          try {
                              map.remove(polygon);
                          } catch (e) {
                              console.warn('移除多边形失败:', e);
                          }
                      }
                  });
              }

              layerProvince = new AMap.LabelsLayer({
                  collision: false,
                  animation: true,
              });
              this.mapObj.layerProvince = layerProvince;
              layerCity = new AMap.LabelsLayer({
                  collision: false,
                  animation: true,
              });
              this.mapObj.layerCity = layerCity;

              // 选中文字样式
              if (!label) {
                  label = new AMap.LabelMarker({
                      ...labelObj,
                      text: {
                          direction: 'center',
                          style: selectStyle,
                      },
                  });
                  map.add(label);
                  this.mapObj.label = label;
                  label.hide();
              }

              for (let i = 0; i < provinceData?.length; i++) {
                  isSelected = adcode && adcode == provinceData[i].adcode;
                  !cityData?.length && provinceData[i].name === '广东省'
                      ? (cityData = JSON.parse(JSON.stringify(provinceData[i].districtList)))
                      : [];

                  let data = provinceData[i];
                  let boxHtml = this.$u.createElm('div');
                  boxHtml.appendChild(
                      this.$u.drawDialog(GisInfoBox, {
                          cityName: data.name,
                          type: 1,
                          dataObj: this.countryQuotaData,
                      }),
                  );
                  let infoWindow = new AMap.InfoWindow({
                      isCustom: true,
                      content: boxHtml,
                      offset: new AMap.Pixel(0, -10),
                  });
                  infoWindow.off('mouseover').on('mouseover', (e) => {
                      let center = [data.center.lng, data.center.lat];
                      infoWindow.open(map, center);
                  });

                  infoWindow.off('mouseout').on('mouseout', (e) => {
                      infoWindow.close();
                  });

                  let obj = {
                      ...labelObj,
                      position: [provinceData[i].center.lng, provinceData[i].center.lat],
                  };
                  obj.text.content = provinceData[i].name;
                  if (isSelected && adcode !== 440000) {
                      label.setPosition(obj.position);
                      label.setText({
                          content: obj.text.content,
                      });
                      label.show();
                  }
                  let labelsMarker = new AMap.LabelMarker(obj);
                  labelsMarker.on('click', (e) => {
                      this.provinceListen(e);
                  });

                  labelsMarker.off('mouseover').on('mouseover', (e) => {
                      let center = [data.center.lng, data.center.lat];
                      infoWindow.open(map, center);
                  });
                  labelsMarker.off('mouseout').on('mouseout', (e) => {
                      infoWindow.close();
                  });
                  !isSelected ? layerProvince.add(labelsMarker) : '';
              }
              map.add(layerProvince);
              city ? layerProvince.hide() : '';

              // 处理城市标签
              this.processCityLabels(cityData, adcode, city, labelObj, selectStyle, label, layerCity, map);

              // 如果已经加载过边界，不再重新加载
              if (cityBoundariesLoading && !shouldFullReload) {
                  console.log('城市边界正在加载中，跳过...');
                  this.mapObj.isSettingLabels = false;
                  return;
              }

              // 异步加载城市边界
              await this.loadCityBoundariesAsync(cityData, city, map, shouldFullReload);

              this.mapObj.lastLoadTime = now;

          } catch (error) {
              console.error('setLabels执行出错:', error);
          } finally {
              this.mapObj.isSettingLabels = false;
          }
      },

// 只清理图层，不清理边界数据
      cleanupLayersOnly() {
          const { map, layerProvince, layerCity } = this.mapObj;

          if (map) {
              if (layerProvince) {
                  try {
                      map.remove(layerProvince);
                  } catch (e) {
                      console.warn('移除省份图层失败:', e);
                  }
              }

              if (layerCity) {
                  try {
                      map.remove(layerCity);
                  } catch (e) {
                      console.warn('移除城市图层失败:', e);
                  }
              }
          }

          // 重置图层引用
          this.mapObj.layerProvince = null;
          this.mapObj.layerCity = null;
      },

// 更新城市边界显示状态
      updateCityBoundariesVisibility(city) {
          const { disCity, map } = this.mapObj;

          if (disCity && disCity.length > 0 && map) {
              disCity.forEach((polygon, index) => {
                  if (polygon) {
                      // 检查是否已在地图上
                      if (!polygon.getMap()) {
                          map.add(polygon);
                      }

                      if (city) {
                          polygon.show();
                      } else {
                          polygon.hide();
                      }
                  }
              });
          }
      },

// 修改异步加载城市边界方法
      async loadCityBoundariesAsync(cityData, city, map, forceReload = false) {
          // 如果正在加载，则取消
          if (this.mapObj.cityBoundariesLoading && !forceReload) {
              console.log('边界加载已在进行中，取消重复调用');
              return;
          }

          this.mapObj.cityBoundariesLoading = true;

          const { AMap } = this;
          const { disCity, loadedCityAdcodes } = this.mapObj;

          console.log('开始加载城市边界，城市数量:', cityData.length, '强制重新加载:', forceReload);

          // 如果强制重新加载，清空缓存
          if (forceReload) {
              this.mapObj.loadedCityAdcodes = new Set();
              this.mapObj.cityBoundariesLoaded = false;
          }

          // 记录加载状态
          this.loadedCityCount = 0;
          this.totalCityCount = cityData.length;

          // 创建加载进度指示器
          this.showLoadingProgress('正在加载城市边界...', 0);

          // 加载单个城市的边界
          const loadCityWithCheck = async (cityItem, index) => {
              const cityAdcode = cityItem.adcode;

              // 检查是否已加载过
              if (!forceReload && loadedCityAdcodes.has(cityAdcode) && disCity[index]) {
                  console.log(`城市已加载，复用: ${cityItem.name}`);
                  this.loadedCityCount++;
                  return;
              }

              try {
                  await this.loadSingleCityBoundary(cityItem, index, city, map, forceReload);
                  loadedCityAdcodes.add(cityAdcode);
                  this.loadedCityCount++;
              } catch (error) {
                  console.error(`加载城市边界失败: ${cityItem.name}`, error);
                  this.loadedCityCount++;
              }
          };

          // 分批加载，每批3个，批次间间隔
          const BATCH_SIZE = 3;
          for (let i = 0; i < cityData.length; i += BATCH_SIZE) {
              const batchEnd = Math.min(i + BATCH_SIZE, cityData.length);
              console.log(`加载批次: ${i + 1}-${batchEnd}/${cityData.length}`);

              // 创建批次Promise数组
              const batchPromises = [];
              for (let j = i; j < batchEnd; j++) {
                  batchPromises.push(loadCityWithCheck(cityData[j], j));
              }

              // 等待批次完成
              await Promise.all(batchPromises);

              // 更新进度
              const progress = Math.round((this.loadedCityCount / this.totalCityCount) * 100);
              this.updateLoadingProgress(`加载城市边界中... (${this.loadedCityCount}/${this.totalCityCount})`, progress);

              // 批次间延迟
              if (batchEnd < cityData.length) {
                  await new Promise(resolve => setTimeout(resolve, 1000));
              }
          }

          // 所有城市加载完成
          this.mapObj.cityBoundariesLoaded = true;
          this.mapObj.cityBoundariesLoading = false;
          this.hideLoadingProgress();
          console.log(`城市边界加载完成: ${this.loadedCityCount}/${cityData.length}`);

          // 如果需要显示城市边界
          if (city) {
              this.showAllCityBoundaries();
          }
      },

// 修改加载单个城市边界方法
      loadSingleCityBoundary(cityItem, index, city, map, forceReload = false) {
          return new Promise((resolve, reject) => {
              const { AMap } = this;
              const { disCity } = this.mapObj;

              // 检查是否已存在且不需要强制重新加载
              if (!forceReload && disCity && disCity[index]) {
                  const existingPolygon = disCity[index];
                  if (existingPolygon && existingPolygon.getMap()) {
                      console.log(`边界已存在，复用: ${cityItem.name}`);

                      // 更新显示状态
                      if (city) {
                          existingPolygon.show();
                      } else {
                          existingPolygon.hide();
                      }

                      resolve();
                      return;
                  }
              }

              // 创建独立的搜索实例
              const citySearch = new AMap.DistrictSearch({
                  level: 'city',
                  extensions: 'all',
                  subdistrict: 0,
              });

              // 设置超时
              const timeoutPromise = new Promise((_, rejectTimeout) => {
                  setTimeout(() => rejectTimeout(new Error('搜索超时')), 8000);
              });

              const searchPromise = new Promise((resolveSearch, rejectSearch) => {
                  citySearch.search(cityItem.adcode, (status, result) => {
                      if (status === 'complete' && result.info === 'OK') {
                          let bounds = result.districtList[0]?.boundaries;
                          if (bounds && bounds.length > 0) {
                              // 如果已存在多边形，先移除
                              if (disCity && disCity[index]) {
                                  try {
                                      map.remove(disCity[index]);
                                  } catch (e) {
                                      // 忽略移除错误
                                  }
                              }

                              // 生成行政区划polygon
                              for (let j = 0; j < bounds.length; j++) {
                                  bounds[j] = [bounds[j]];
                              }

                              const colorArr = this.getColorByVal(cityItem.name, false, true);
                              const polygon = new AMap.Polygon({
                                  zIndex: 30,
                                  strokeWeight: 1,
                                  path: bounds,
                                  strokeColor: '#49f3f3',
                                  fillOpacity: colorArr[1],
                                  fillColor: colorArr[0],
                              });

                              map.add(polygon);

                              // 存储到数组
                              this.mapObj.disCity[index] = polygon;

                              // 创建信息窗口
                              let boxHtml = this.$u.createElm('div');
                              boxHtml.appendChild(
                                  this.$u.drawDialog(GisInfoBox, {
                                      cityName: cityItem.name,
                                      type: 2,
                                  }),
                              );

                              let infoWindow = new AMap.InfoWindow({
                                  isCustom: true,
                                  content: boxHtml,
                                  offset: new AMap.Pixel(0, -10),
                              });

                              // 绑定事件
                              polygon.off('mouseover').on('mouseover', (e) => {
                                  infoWindow.open(map, cityItem.center);
                              });

                              infoWindow.off('mouseover').on('mouseover', (e) => {
                                  infoWindow.open(map, cityItem.center);
                              });

                              polygon.off('mouseout').on('mouseout', (e) => {
                                  infoWindow.close();
                              });

                              infoWindow.off('mouseout').on('mouseout', (e) => {
                                  infoWindow.close();
                              });

                              polygon.off('click').on('click', (e) => {
                                  this.$emit('mapCode', {
                                      code: 440000,
                                      name: cityItem.name.split('市')[0],
                                  });
                                  this.cityListen(e, { infoWindow, infoWindowData: cityItem });
                              });

                              // 如果不需要显示城市，就隐藏
                              if (!city) {
                                  polygon.hide();
                              } else {
                                  polygon.show();
                              }

                              console.log(`✓ 城市边界已加载: ${cityItem.name}`);
                              resolveSearch();
                          } else {
                              console.warn(`⚠ 无边界数据: ${cityItem.name}`);
                              resolveSearch(); // 仍然resolve，只是没有数据
                          }
                      } else {
                          rejectSearch(new Error(`搜索失败: ${cityItem.name}, 状态: ${status}`));
                      }
                  });
              });

              // 使用Promise.race添加超时控制
              Promise.race([searchPromise, timeoutPromise])
                  .then(() => resolve())
                  .catch(error => {
                      console.error(`✗ 加载失败: ${cityItem.name}`, error.message);
                      resolve(); // 即使失败也继续下一个
                  });
          });
      },

// 修改地图点击事件处理
      cityListen(e, infoWindowObj) {
          // 先停止事件冒泡
          e && e.stopPropagation && e.stopPropagation();

          // 获取城市信息
          const cityName = infoWindowObj?.infoWindowData?.name || '';
          const cityCode = infoWindowObj?.infoWindowData?.adcode || '';

          console.log('点击城市:', cityName, cityCode);

          // 添加防重复点击
          const now = Date.now();
          if (this.lastCityClickTime && now - this.lastCityClickTime < 1000) {
              console.log('点击过于频繁，跳过');
              return;
          }
          this.lastCityClickTime = now;

          // 延迟执行，避免频繁触发
          setTimeout(() => {
              this.$emit('cityListen', {
                  ...infoWindowObj,
                  cityName,
                  cityCode
              });

              // 这里不直接调用setLabels，而是通过其他方式触发
              // 如果确实需要重新加载，可以设置一个标记
              this.shouldReloadOnNextTick = true;
          }, 100);
      },
      cleanupMapLayers() {
          const { map, layerProvince, layerCity, disCity } = this.mapObj;

          if (map) {
              if (layerProvince) {
                  try {
                      map.remove(layerProvince);
                  } catch (e) {
                      console.warn('移除省份图层失败:', e);
                  }
              }

              if (layerCity) {
                  try {
                      map.remove(layerCity);
                  } catch (e) {
                      console.warn('移除城市图层失败:', e);
                  }
              }

              if (disCity && disCity.length > 0) {
                  disCity.forEach(polygon => {
                      if (polygon) {
                          try {
                              map.remove(polygon);
                          } catch (e) {
                              console.warn('移除多边形失败:', e);
                          }
                      }
                  });
              }
          }

          // 重置图层引用
          this.mapObj.layerProvince = null;
          this.mapObj.layerCity = null;
          this.mapObj.cityBoundariesLoading = false;
      },
      processCityLabels(cityData, adcode, city, labelObj, selectStyle, label, layerCity, map) {
          for (let i = 0; i < cityData.length; i++) {
              const isSelected = adcode && adcode == cityData[i].adcode;

              // 创建城市标签
              let obj = {
                  ...labelObj,
                  position: cityData[i].center,
              };
              obj.text.content = cityData[i].name;

              if (isSelected) {
                  label.setPosition(obj.position);
                  label.setText({
                      content: obj.text.content,
                  });
                  label.show();
              }

              let labelsMarker = new AMap.LabelMarker(obj);
              labelsMarker.off('click').on('click', (e) => {
                  this.$emit('mapCode', {
                      code: 440000,
                      name: cityData[i].name.split('市')[0],
                  });
                  this.cityListen(e);
              });

              layerCity.add(labelsMarker);
          }

          // 添加城市标签层到地图
          map.add(layerCity);
          !city ? layerCity.hide() : '';
      },
      // 显示加载进度
      showLoadingProgress(message, progress) {
          // 这里实现你的进度条显示逻辑
          // 例如：this.$message.loading(`${message} ${progress}%`);
          console.log(`${message} ${progress}%`);
      },
      // 更新加载进度
      updateLoadingProgress(message, progress) {
          // 更新进度条
          console.log(`${message} ${progress}%`);
      },

// 隐藏加载进度
      hideLoadingProgress() {
          // 隐藏进度条
          console.log('加载完成');
      },



      setCityColor() {
      let { provinceData, cityData, disCity } = this.mapObj;
      if (disCity?.length) {
        let cityGD = provinceData.filter((item) => item.name === '广东省')[0];
        if (cityGD) {
          cityData = JSON.parse(JSON.stringify(cityGD.districtList));
        }
        disCity = disCity.map((item, i) => {
          let colorArr = this.getColorByVal(cityData[i].name, false, true);
          console.log(colorArr, 'colorArr');
          item.setOptions({
            fillOpacity: colorArr[1],
            fillColor: colorArr[0],
          });
        });
      }
    },
    mapListen() {
      let { map, AMap } = this;
      let that = this;
      let {
        layerProvince,
        layerCity,
        disCountry,
        proOptions,
        disProvince,
        focusProvince,
        polygonCity,
        provinceData,
        label,
      } = this.mapObj;

      map.off('complete').on('complete', function () {
        provinceData ? that.setLabels() : '';
      });

      map.off('click').on('click', (e) => {
        this.provinceListen(e);
      });
    },
    provinceListen(e) {
      let { map, AMap } = this;
      let {
        layerProvince,
        layerCity,
        disCountry,
        proOptions,
        disProvince,
        focusProvince,
        polygonCity,
        provinceData,
        label,
      } = this.mapObj;

      var px = e.pixel;
      var props =
        this.selectId > 1 ? disProvince.getDistrictByContainerPos(px) : disCountry.getDistrictByContainerPos(px);

      if (!props) {
        focusProvince.setDistricts('');
        focusProvince.setMap(map);
        label.hide();

        if (this.selectId === 440000) {
          if (polygonCity) {
            map.remove(polygonCity); //清除上次结果
            polygonCity = null;
          }
          this.setLabels('', true);
          // layerProvince.hide();
          // layerCity.show();
        } else {
          this.setLabels();
        }
      }

      if (props?.NAME_CHN && this.selectId === 1) {
        this.setLabels(props.adcode);
        if (props.NAME_CHN === '广东省') {
          this.selectId = 440000;
        } else {
          this.selectId = 1;
          focusProvince.setDistricts(props.adcode + '');
          focusProvince.setMap(map);
          layerProvince?.show();
          layerCity?.hide();
        }
      }

      this.$emit('mapCode', {
        code: this.selectId,
        name: this.selectId > 1 ? '' : props?.NAME_CHN,
      });
    },
    cityListen(e, infoData) {
      let { map, AMap } = this;
      let { polygonCity, layerProvince, layerCity } = this.mapObj;
      let { infoWindow, infoWindowData } = infoData;
      let geocoder = new AMap.Geocoder({
        city: '全国',
      });
      if (polygonCity) {
        map.remove(polygonCity); //清除上次结果
        polygonCity = null;
      }
      geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          let { adcode, city, citycode } = result.regeocode.addressComponent;
          adcode = `${adcode.slice(0, 4)}00`;

          let citySearch = new AMap.DistrictSearch({
            // adcode: 440000,
            // level: "province",
            level: 'district',
            extensions: 'all',
            subdistrict: 1, //  显示下级行政区级数
          });

          citySearch.search(adcode, (status, result) => {
            if (status == 'complete') {
              console.log(result, 'result');
              let bounds = result.districtList[0].boundaries;
              // 区县
              // let list = result.districtList[0].districtList;
              // list.map(item => {
              //   citySearch.search(item.name, (status1, result1) => {
              //     console.log(status1, result1)
              //   })
              // })
              if (bounds) {
                //生成行政区划polygon
                for (var i = 0; i < bounds.length; i += 1) {
                  //构造MultiPolygon的path
                  bounds[i] = [bounds[i]];
                }
                polygonCity = new AMap.Polygon({
                  strokeWeight: 1,
                  path: bounds,
                  fillOpacity: 1,
                  fillColor: '#49f3f3',
                  // fillColor: 'rgba(231, 223, 180, .8)',
                  strokeColor: '#49f3f3',
                });
                map.add(polygonCity);
                this.mapObj.polygonCity = polygonCity;

                // let boxHtml = this.$u.createElm("div");
                // boxHtml.appendChild(
                //   this.$u.drawDialog(GisInfoBox, {
                //     cityName: city
                //   })
                // );
                // let infoWindow = new AMap.InfoWindow({
                //   isCustom: true,  //使用自定义窗体
                //   content: boxHtml,
                //   offset: new AMap.Pixel(0, -10)
                // });

                if (!infoWindow) return;

                polygonCity.off('mouseover').on('mouseover', (e) => {
                  infoWindow.open(map, infoWindowData.center);
                });

                infoWindow.off('mouseover').on('mouseover', (e) => {
                  infoWindow.open(map, infoWindowData.center);
                });

                polygonCity.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                infoWindow.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });
              }
            }
          });
          this.setLabels(adcode, true);
        }
      });
    },
  },
  mounted() {
    this.getData();
    this.initMap();
      // 监听是否需要重新加载
      this.$nextTick(() => {
          if (this.shouldReloadOnNextTick) {
              this.shouldReloadOnNextTick = false;
              // 可以在这里触发特定的重新加载逻辑
          }
      });

  },
  beforeDestroy() {
    // this.map?.destory();
  },
};
</script>

<style lang="less" scoped>
.aMap {
  width: 100%;
  height: 1250px;
  //height: 100%;
  margin: 0;
  //margin-left: 4px;
  /*transform: scale(.92);*/

  #map {
    width: 100%;
    height: 100%;
    background: transparent !important;
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 1;
  }

  /deep/ .amap-logo,
  /deep/ .amap-copyright {
    display: none !important;
  }

  .map-loading {
    /*width: calc(100% + 40px);*/
    /*height: calc(100% - 100px);*/
    width: 3200px;
    height: 1080px;
    background: url('~img/home/home-bg.jpg') no-repeat;
    background-size: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 2;
    /*backdrop-filter: blur(20px);*/

    /deep/.el-icon-loading {
      font-size: 30px;
      color: #fff;
    }
  }

  .point {
    font-size: 18px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #aafdfe;
    line-height: 43px;
    margin-top: 20px;
    margin-left: 70px;
    position: absolute;
    z-index: 2;
    .flex-center();

    /deep/.el-switch {
      width: 80px;
      position: relative;
      .el-switch__label * {
        line-height: 1;
        font-size: 14px;
        display: inline-block;
      }
      .el-switch__label {
        display: none;
        position: absolute;
        color: #fff;
        &.is-active {
          word-break: keep-all;
          display: block;
        }
      }
      .el-switch__label--right {
        z-index: 1;
        left: 5px;
      }
      /*关闭时文字位置设置*/
      .el-switch__label--left {
        /*color: #aafdfe;*/
        z-index: 1;
        right: 5px;
      }
      /*开关宽度*/
      .el-switch__core {
        color: #fff;
        width: 80px !important;

        &::after {
          border-radius: 50%;
          box-shadow: rgba(0, 0, 0, 0.1);
        }
      }
      .el-switch__core {
      }
      &.is-check {
        .el-switch__core {
          background: #aafdfe;
        }
      }
    }

    /deep/.element-select {
      height: 100%;

      .el-input__suffix,
      .el-input__suffix-inner {
        height: 100%;
        top: 50%;
        transform: translateY(-15%);
      }

      .el-select-dropdown {
        top: 229px !important;
      }
    }
  }

  .map-radio-box {
    position: absolute;
    top: 690px;
    z-index: 2;

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #aafdfe;
      line-height: 43px;

      span {
        display: inline-block;
        width: 22px;
        height: 16px;
        background: url('~img/home/map-draw.png') no-repeat;
        background-size: 100% 100%;
        margin-right: 10px;
      }
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
      box-shadow: none !important;
    }

    /deep/.el-radio-group {
      margin-left: 40px;
      display: flex;
      flex-direction: column;

      .el-radio {
        color: rgba(170, 253, 254, 0.6) !important;
        line-height: 43px;
        .flex-center();

        &.is-focus {
          color: #aafdfe;
        }
      }

      .el-radio__input.is-checked {
        .el-radio__inner {
          border-color: #aafdfe;
          background-color: transparent;

          &::after {
            background: #aafdfe;
          }
        }

        + .el-radio__label {
          color: #aafdfe;
        }
      }

      .el-radio__input {
        width: 18px;
        height: 18px;
      }

      .el-radio__inner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(170, 253, 254, 0.6);
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 50%;

        &:hover {
          border-color: #aafdfe !important;
        }

        &::after {
          background: transparent;
          width: 10px;
          height: 10px;
          transform: translate(-43%, -43%);
        }
      }
    }
  }

  .map-color-box {
    position: absolute;
    right: 0;
    top: 650px;
    /*top: 800px;*/
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: normal;
    color: #c0c0c0;
    line-height: 24px;
    text-shadow: 0px 2px 2px rgba(16, 16, 16, 0.6);
    z-index: 2;

    .map-color {
      width: 17px;
      height: 150px;
      border: 1px solid #00c9ff;
      /*background: linear-gradient(0deg, rgba(27, 95, 152, .5) 0%, rgba(73, 243, 243, 0.75) 100%);*/
      /*background: linear-gradient(0deg, rgba(27, 95, 152, 0.5) 0%, rgba(73, 243, 243, 0.4) 100%);*/
      background: linear-gradient(0deg, #0078ff 0%, #00c9ff 36%, #58ecac 71%, #fcf5c2 100%);
      border-radius: 6px;
    }

    &::before {
      content: '高(会员总数)';
      line-height: 30px;
    }

    &::after {
      content: '低(会员总数)';
      line-height: 30px;
    }

    .num-box {
      height: calc(100% - 50px);
      position: absolute;
      text-align: right;
      top: 25px;
      right: 90px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #c0c0c0;
      line-height: 24px;
      text-shadow: 0 2px 2px rgba(16, 16, 16, 0.6);
    }
  }
}
</style>
